module.exports = __webpack_public_path__ + "static/img/monitor_item_image4.45015a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/monitor_item_image4.png
// module id = M/Gh
// module chunks = 1